import { User } from '@spartacus/user/account/root';

declare module '@spartacus/user/account/root' {
  interface User {
    exclusiveRole?: string;
    supportedOnBehalfOfExclusiveRole?: string;
    documentIdentifier?: string;
    publicRole?: string;
  }
}